import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { BidService } from '@6grain/masofa-monolith-api-client/crop-monitoring/api/bid.service';

@Component({
  selector: 'app-api-test',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="api-test-container">
      <h2>API Configuration Test</h2>
      
      <div class="environment-info">
        <h3>Current Environment</h3>
        <p><strong>Production:</strong> {{ environment.production }}</p>
        <p><strong>Authority:</strong> {{ environment.authority }}</p>
        <p><strong>Gateway:</strong> {{ environment.gateway }}</p>
      </div>
      
      <div class="api-actions">
        <h3>API Test Actions</h3>
        <button (click)="testApiConnection()">Test API Connection</button>
        <button (click)="testBidsCount()">Test Bids Count</button>
        <button (click)="testDirectFetch()">Test Direct Fetch</button>
        <button (click)="testBids()">Test Bids API</button>
        <button (click)="showEnvironmentDetails()">Show Environment Details</button>
      </div>
      
      <div class="results" *ngIf="testResults">
        <h3>Test Results</h3>
        <pre>{{ testResults | json }}</pre>
      </div>
    </div>
  `,
  styles: [`
    .api-test-container {
      padding: 20px;
      max-width: 800px;
      margin: 0 auto;
      color: black;
    }
    
    .environment-info {
      background: #f5f5f5;
      padding: 15px;
      border-radius: 5px;
      margin-bottom: 20px;
    }
    
    .environment-info p {
      margin: 5px 0;
    }
    
    .api-actions button {
      margin-right: 10px;
      padding: 10px 20px;
      background: #007bff;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
    }
    
    .api-actions button:hover {
      background: #0056b3;
    }
    
    .results {
      margin-top: 20px;
      background: #f8f9fa;
      padding: 15px;
      border-radius: 5px;
    }
    
    pre {
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  `]
})
export class ApiTestComponent implements OnInit {
  environment = environment;
  testResults: any = null;
  
  constructor(
    private bidService: BidService
  ) {}
  
  ngOnInit() {
  }
  
  testApiConnection() {
    this.testResults = {
      message: 'API client configured',
      timestamp: new Date().toISOString(),
      gateway: environment.gateway,
      authority: environment.authority,
      status: 'Ready to test API endpoints'
    };
  }
  
  testBidsCount() {
    this.testResults = { status: 'Loading bids count...' };
    
    const token = localStorage.getItem('access_token');
    
    this.bidService.cropMonitoringBidGetByQueryPost({
      take: 10,
      offset: 0,
      filters: null
    }).subscribe({
      next: (bids) => {
        this.testResults = {
          success: true,
          message: 'Bids loaded successfully',
          count: bids.length,
          sample: bids.slice(0, 3)
        };
      },
      error: (err) => {
        console.error('Bid API Error:', err);
        this.testResults = {
          error: true,
          message: err.message || 'Failed to load bids',
          status: err.status,
          statusText: err.statusText,
          url: err.url,
          errorDetails: err.error
        };
      }
    });
  }
  
  testBids() {
    this.testResults = { status: 'Loading bids...' };
    this.bidService.cropMonitoringBidGetByQueryPost({
      take: 1000,
      offset: 0,
      filters: null
    }).subscribe({
      next: (bids: any) => {
        this.testResults = {
          success: true,
          count: bids.length,
          sample: bids.slice(0, 3)
        };
      },
      error: (err: any) => {
        this.testResults = {
          error: true,
          message: err.message || 'Failed to load bids',
          status: err.status,
          details: err
        };
      }
    });
  }
  
  showEnvironmentDetails() {
    this.testResults = {
      fullEnvironment: environment,
      currentUrl: window.location.href,
      userAgent: navigator.userAgent
    };
  }
  
  testDirectFetch() {
    this.testResults = { status: 'Testing direct bid fetch...' };
    
    const token = localStorage.getItem('access_token');
    if (!token) {
      this.testResults = { error: 'No token found in localStorage!' };
      return;
    }
    
    this.bidService.cropMonitoringBidGetByQueryPost({
      take: 5,
      offset: 0,
      filters: null
    }).subscribe({
      next: (bids) => {
        this.testResults = {
          method: 'BidService',
          status: 200,
          statusText: 'OK',
          success: true,
          count: bids.length,
          data: bids
        };
      },
      error: (error) => {
        console.error('BidService error:', error);
        this.testResults = {
          method: 'BidService',
          error: true,
          status: error.status,
          statusText: error.statusText,
          message: error.message || 'BidService failed'
        };
      }
    });
  }
}